import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { BASE_URL } from './base-url';

@Injectable({
  providedIn: 'root'
})
export class TvProductionTrackerService {

  base_URL = BASE_URL;

  constructor(public http: HttpClient) { }

  createEpisode(body: any) {
    return this.http.post(this.base_URL + 'tvProductionTracker', body);
  }

  updateEpisodeWorkflow(body: any) {
    return this.http.put(this.base_URL + 'tvProductionTracker/update', body);
  }

  updateCommonNotes(id: any, body: any) {
    return this.http.put(this.base_URL + 'tvProductionTracker/updateCommonNotes/' + id, body);
  }

  getEpisodeById(id: any) {
    return this.http.get(this.base_URL + 'tvProductionTracker/' + id + '/' + sessionStorage.getItem('cid'));
  }

  getAllEpisodes() {
    return this.http.get(this.base_URL + 'tvProductionTracker/all/' + sessionStorage.getItem('cid'));
  }

  getAllTvProductionTrackersUserId(userId: any) {
    return this.http.get(this.base_URL + 'tvProductionTracker/getAllTvProductionTrackersUserId/' + userId + '/' + sessionStorage.getItem('cid'));
  }

  softDeleteEpisode(id: any) {
    return this.http.delete(this.base_URL + 'tvProductionTracker/softDelete/' + id);
  }

  hardDeleteEpisode(id: any) {
    return this.http.delete(this.base_URL + 'tvProductionTracker/hardDelete/' + id);
  }

  filterByWildSearch(body: any) {
    return this.http.post(this.base_URL + 'tvProductionTracker/filterByWildSearch/' + sessionStorage.getItem('cid'), body);
  }

  filterByShootDate(body: any) {
    return this.http.post(this.base_URL + 'tvProductionTracker/filterByShootDate/' + sessionStorage.getItem('cid'), body);
  }

  filterByPriority(body: any) {
    return this.http.post(this.base_URL + 'tvProductionTracker/filterByPriority/' + sessionStorage.getItem('cid'), body);
  }

  filterByEpisodeType(body: any) {
    return this.http.post(this.base_URL + 'tvProductionTracker/filterByEpisodeType/' + sessionStorage.getItem('cid'), body);
  }

  filterByEpisodeStatus(body: any) {
    return this.http.post(this.base_URL + 'tvProductionTracker/filterByEpisodeStatus/' + sessionStorage.getItem('cid'), body);
  }

  filterTvProductionTracker(cid: number, payload: any) {
    return this.http.post(`${this.base_URL}tvProductionTracker/filter/${cid}`, payload);
  }
}
